import React from 'react';
import Icon from '../../../components/AppIcon';

const ScheduleCard = ({
  schedule,
  onEdit,
  onDelete,
  onManageRecipients,
  onSendTest,
  isSending,
  getReportTypeLabel,
  getFrequencyLabel
}) => {
  const getStatusColor = (status) => {
    const colors = {
      active: 'bg-green-100 text-green-800',
      paused: 'bg-yellow-100 text-yellow-800',
      inactive: 'bg-gray-100 text-gray-800'
    };
    return colors?.[status] || colors?.inactive;
  };

  const getReportIcon = (type) => {
    const icons = {
      financial_report: 'DollarSign',
      client_analytics: 'Users',
      threshold_alerts: 'AlertTriangle'
    };
    return icons?.[type] || 'Mail';
  };

  const activeRecipients = schedule?.recipients?.filter(r => r?.isActive)?.length || 0;

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="p-3 bg-primary/10 rounded-lg">
            <Icon name={getReportIcon(schedule?.reportType)} size={24} className="text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">{schedule?.reportName}</h3>
            <p className="text-sm text-muted-foreground">
              {getReportTypeLabel(schedule?.reportType)}
            </p>
          </div>
        </div>
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(schedule?.status)}`}>
          {schedule?.status}
        </span>
      </div>
      <div className="space-y-3 mb-4">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Clock" size={16} />
          <span>{getFrequencyLabel(schedule?.frequency)} at {schedule?.scheduleTime}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Users" size={16} />
          <span>{activeRecipients} active recipient{activeRecipients !== 1 ? 's' : ''}</span>
        </div>
        {schedule?.lastSentAt && (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Send" size={16} />
            <span>Last sent: {new Date(schedule?.lastSentAt)?.toLocaleDateString()}</span>
          </div>
        )}
        {schedule?.nextScheduledAt && (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Calendar" size={16} />
            <span>Next: {new Date(schedule?.nextScheduledAt)?.toLocaleDateString()}</span>
          </div>
        )}
      </div>
      <div className="flex gap-2">
        <button
          onClick={onEdit}
          className="flex-1 px-3 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-smooth press-effect focus-ring text-sm"
        >
          <Icon name="Edit" size={16} className="inline mr-1" />
          Edit
        </button>
        <button
          onClick={onManageRecipients}
          className="flex-1 px-3 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-smooth press-effect focus-ring text-sm"
        >
          <Icon name="Users" size={16} className="inline mr-1" />
          Recipients
        </button>
      </div>
      <div className="flex gap-2 mt-2">
        <button
          onClick={onSendTest}
          disabled={isSending}
          className="flex-1 px-3 py-2 bg-primary/10 text-primary rounded-lg hover:bg-primary/20 transition-smooth press-effect focus-ring text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSending ? (
            <>
              <Icon name="Loader2" size={16} className="inline mr-1 animate-spin" />
              Sending...
            </>
          ) : (
            <>
              <Icon name="Send" size={16} className="inline mr-1" />
              Test
            </>
          )}
        </button>
        <button
          onClick={onDelete}
          className="px-3 py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-smooth press-effect focus-ring text-sm"
        >
          <Icon name="Trash2" size={16} />
        </button>
      </div>
    </div>
  );
};

export default ScheduleCard;